// English remains available in the initial shell. Reviewed non-English copy
// is one cacheable, on-demand payload, loaded before a non-English preference
// becomes active so no screen renders a partial locale.
let cache = null;
let pending = null;

if (process.env.NODE_ENV === "test") {
  // Translation helper tests intentionally keep their synchronous public
  // contract. This branch is removed from production bundles.
  // eslint-disable-next-line global-require
  cache = require("./deferredTranslationCatalogues").deferredTranslationCatalogues;
}

export function loadedTranslationCatalogues() {
  return cache;
}

export function loadDeferredTranslationCatalogues() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = import(
      /* webpackChunkName: "locale-reviewed-catalogues" */ "./deferredTranslationCatalogues"
    ).then(({ deferredTranslationCatalogues }) => {
      cache = deferredTranslationCatalogues;
      return cache;
    }).catch((error) => {
      pending = null;
      throw error;
    });
  }
  return pending;
}
